import React from "react";
import { memo } from "react";

type CounterProps = {
	number: number;
};

function Counter({ number }: CounterProps) {
	if (number <= 0) return null;
	return (
		<div
			style={{
				backgroundColor: "#EF4444",
				borderRadius: 24,
				width: 20,
				height: 20,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
        color: "#FFFFFF",
			}}
		>
			<p>{number}</p>
		</div>
	);
}

export default memo(Counter);
